/**
 * Safely retrieves a value from sessionStorage or localStorage.
 * Falls back gracefully when storage is unavailable (e.g., private browsing, disabled storage).
 */
export const getStorageItem = (key: string, storage: 'session' | 'local' = 'local'): string | null => {
    try {
        return storage === 'session'
            ? sessionStorage.getItem(key)
            : localStorage.getItem(key);
    } catch {
        return null;
    }
};

/**
 * Retrieves the encrypted household ID from sessionStorage or localStorage.
 */
export const getEncHouseholdId = (): string | null => {
    return getStorageItem('encHouseHoldId', 'session') || getStorageItem('HK_encHouseholdId', 'local');
};
